import React, { useState, useEffect, useRef } from "react";
import "../styles/GalleryCarousel.css";
import img1 from "../assets/images/IMG_1.jpeg";
import img2 from "../assets/images/IMG_2.jpeg";
import img3 from "../assets/images/IMG_3.jpeg";
import img4 from "../assets/images/IMG_4.jpeg";
import img5 from "../assets/images/IMG_5.jpeg";
import img6 from "../assets/images/IMG_6.jpeg";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const imageData = [
  {
    image: img1,
    text: "Awarded by the School Principal after taking a Career Guidance and Leadership session in Schools.",
  },
  { image: img3, text: "Motivational Speaker Training on Leadership." },
  { image: img4, text: "Speaking to Students about Career Guidance" },
  {
    image: img5,
    text: "Personal Counselling for Student in St. Aloysious School, Jabalpur.",
  },
  {
    image: img6,
    text: "Awarded as he amongst the Top 50 Most Influential Authors in 2024.",
  },
];

const GalleryCarousel = () => {
  const [current, setCurrent] = useState(0);
  const [isManual, setIsManual] = useState(false);
  const length = imageData.length;
  const intervalRef = useRef(null);

  // Auto-scroll every 5 seconds unless manually scrolled
  useEffect(() => {
    if (!isManual) {
      intervalRef.current = setInterval(() => {
        setCurrent((prev) => (prev + 1) % length);
      }, 10000);
    }
    return () => clearInterval(intervalRef.current);
  }, [length, isManual]);

  const goToPrev = () => {
    setCurrent((prev) => (prev - 1 + length) % length);
    setIsManual(true);
    clearInterval(intervalRef.current);
  };

  const goToNext = () => {
    setCurrent((prev) => (prev + 1) % length);
    setIsManual(true);
    clearInterval(intervalRef.current);
  };

  return (
    <section className="gallery-carousel-section">
      <div className="gallery-carousel-container single-image-carousel">
        <button
          className="scroll-btn left"
          onClick={goToPrev}
          aria-label="Scroll left"
        >
          <FaChevronLeft />
        </button>
        <div className="carousel-image-wrapper">
          <img
            src={imageData[current].image}
            alt={`Gallery ${current + 1}`}
            className="carousel-image"
            style={
              imageData[current].image === img6
                ? {
                    objectFit: "contain",
                    background: "var(--background-white)",
                  }
                : { objectFit: "cover" }
            }
          />
          <div className="carousel-context-text">{imageData[current].text}</div>
        </div>
        <button
          className="scroll-btn right"
          onClick={goToNext}
          aria-label="Scroll right"
        >
          <FaChevronRight />
        </button>
      </div>
      <p className="gallery-carousel-text">
        I'm committed to helping more people like you to get the results they
        want, every day. <br />
        To make it easy, there are lots of ways you can work with me! The range
        of services I offer, at a simple Professional charge, can be tweaked to
        suit your Career goals, business, or a project. <br />
        And it's worth saying that I specialize in working outside-the-box, so
        if you're looking for new ways to bring your latest project to life then
        I'll develop a solution that's truly unique.
      </p>
    </section>
  );
};

export default GalleryCarousel;
